import { LanguageLevel } from '@asgard/common-dto';
import { PublicManfredite } from 'interfaces/public-manfredite.interface';
import { getPublicPath } from 'utils/paths';

const CvApplicationSampleManfredite: PublicManfredite = {
  headline: {
    EN: "Director of Software Engineering Division at MIT's Instrumentation Laboratory"
  },
  whereDoYouLive: {
    displayName: {
      ES: 'Massachusetts, EE.UU',
      EN: 'Massachusetts, USA'
    },
    placeId: 'xxxxxxxx'
  },
  introduction: {
    EN: "Hi! I'm Margaret Heafield Hamilton. I'm an American computer scientist, systems engineer and business owner. Once, I was director of the Software Engineering Division of the MIT Instrumentation Laboratory, which developed on-board flight software for NASA's Apollo program. I have also founded two software companies—Higher Order Software in 1976 and Hamilton Technologies in 1986, both in Cambridge, Massachusetts."
  },
  goodPractices: { ES: '' },
  facts: [
    {
      title: {
        EN: 'Some people consider myself as the first person to become a Site Reliability Engineer. Ah! Also, I coined the term Software Engineering.'
      },
      description: {
        EN: '* More than 130 papers published\n* 60 projects\n* 6 major programs'
      }
    }
  ],
  profile: {
    firstName: 'Margaret H.',
    lastName: 'Hamilton',
    avatar: {
      url: getPublicPath('/images/MargaretHHamilton.jpg'),
      alt: { ES: 'avatar.png' },
      id: 1,
      title: '',
      filename: '',
      ownerId: 1,
      uploadPath: ''
    },
    links: {
      others: [
        {
          url: 'https://www.getmanfred.com/profile/margaret_hamilton',
          desc: 'About Me'
        }
      ],

      linkedin: ''
    }
  },
  softSkills: [
    {
      name: { EN: 'Leadership skills' },
      description: {},
      icon: {
        url: 'https://media-asgard.s3.eu-west-1.amazonaws.com/0af23937-4368-43bd-8846-455238c9d50e_Theme%3DLight%2C%20Category%3DSkills%2C%20Type%3DLeadership.svg',
        alt: { EN: 'Leadership_Skills_Icon' },
        id: 1,
        title: '',
        filename: '',
        ownerId: 1,
        uploadPath: ''
      }
    },
    {
      name: { EN: 'Team management' },
      description: {},
      icon: {
        url: 'https://media-asgard.s3.eu-west-1.amazonaws.com/fceedfc0-aa24-43b2-adfd-fd045c2a393d_Theme%3DLight%2C%20Category%3DLiabilities%2C%20Type%3DFace%20to%20face.svg',
        alt: { EN: 'Team_Management_Icon' },
        id: 1,
        title: '',
        filename: '',
        ownerId: 1,
        uploadPath: ''
      }
    },
    {
      name: { EN: 'Analytical thinking' },
      description: {},
      icon: {
        url: 'https://media-asgard.s3.eu-west-1.amazonaws.com/5a9f97a9-b652-45ec-a8b1-b2b3d0971e58_Theme%3DLight%2C%20Category%3DSkills%2C%20Type%3DPositivity.svg',
        alt: { EN: 'Analytical_Thinking_Icon' },
        id: 1,
        title: '',
        filename: '',
        ownerId: 1,
        uploadPath: ''
      }
    }
  ],
  languages: [
    { name: { EN: 'English' }, level: LanguageLevel.NativeBilingual }
  ],
  techs: [],
  techsLike: [],
  techsDislike: [],
  career: [
    {
      company: 'Charles Stark Draper Laboratory at MIT',
      position: {
        ES: 'Systems Designer'
      },
      from: '1963-05-01T12:00:00.000Z',
      description: {
        ES: 'I was initially hired as a programmer for this process, but moved on into system designs. By 1965, I was in charge of al Command Module software, which was all the software for navigation and lunar landing guidance. All for the Apollo command module. '
      },
      to: '1976-05-01T12:00:00.000Z',
      techs: [],
      logo: {
        url: 'https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/27/56f4b69f-a224-4b1c-8174-65737961d1ed_2560px-mit_logo.png',
        alt: {
          ES: '2560px-MIT_logo.svg.png'
        },
        id: 1,
        title: '',
        filename: '',
        ownerId: 1,
        uploadPath: ''
      }
    },
    {
      company: 'NASA (Apollo flight)',
      position: {
        ES: 'Software Designer'
      },
      from: '1965-05-01T12:00:00.000Z',
      description: {
        ES: 'My "priority display" innovation had created a knock-on risk that astronaut and computer would slip out of synch just when it mattered most. As the alarms went off and priority displays replaced normal ones, the actual switchover to new programmes behind the screens was happening "a step slower" than it would today.'
      },
      to: '1970-05-01T12:00:00.000Z',
      techs: [],
      logo: {
        url: 'https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/27/37a26fdd-6b6c-4f8d-90bf-849ab7aa07d3_nasa_logo.png',
        alt: {
          ES: 'NASA_logo.svg.png'
        },
        id: 1,
        title: '',
        filename: '',
        ownerId: 1,
        uploadPath: ''
      }
    },
    {
      company: 'MIT',
      position: {
        ES: 'Software Programmer at MIT Lincoln Lab'
      },
      from: '1961-05-01T12:00:00.000Z',
      description: {
        ES: 'From 1961 to 1963 I worked on the Semi-Automatic Ground Environment (SAGE) Project at the MIT Lincoln Lab, where I was one of the programmers who wrote software for the Prototype AN/FSQ.7 computer, used by the U.S. Air Force to search for possibly unfriendly aircraft. '
      },
      to: '1963-05-01T12:00:00.000Z',
      techs: [],
      logo: {
        url: 'https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/27/080c93bf-c0af-437a-9d9b-77781d86d0b5_2560px-mit_logo.png',
        alt: {
          ES: '2560px-MIT_logo.svg.png'
        },
        id: 1,
        title: '',
        filename: '',
        ownerId: 1,
        uploadPath: ''
      }
    }
  ],
  projects: [
    {
      manfrediteId: 1,
      type: 'SIDE_PROJECT',
      title: {
        ES: 'Coding Software for the Apollo 11 Mission'
      },
      description: {
        ES: 'I was in charge of the codification of Software for the Apollo 11 Mission, the one who took for the very first time the man to the Moon.'
      },
      from: '1969-07-01T12:00:00.000Z',
      to: '1969-08-01T12:00:00.000Z',
      techs: [],
      logo: {
        url: 'https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/28/72a4a682-5519-4733-83ae-f52b0b3fbd39_nasa_logo.png',
        alt: {
          ES: 'NASA_logo.svg.png'
        },
        id: 1,
        title: '',
        filename: '',
        ownerId: 1,
        uploadPath: ''
      }
    }
  ],
  highlights: [
    {
      type: 'AWARD',
      title: {
        ES: 'Computer History Museum Fellow Award'
      },
      category: {
        ES: ''
      },
      description: {
        ES: 'Which honors exceptional men and women whose computing ideas have changed the world.'
      },
      date: '2017-04-01T12:00:00.000Z',
      techs: [],
      logo: {
        url: 'https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/27/7e83380f-7aff-43e3-811b-537ccff84817_fa-gallery-05.jpg',
        alt: {
          ES: 'fa-gallery-05.jpg'
        },
        id: 1,
        title: '',
        filename: '',
        ownerId: 1,
        uploadPath: ''
      }
    },
    {
      type: 'AWARD',
      title: {
        ES: 'The Washington Award'
      },
      category: {
        ES: ''
      },
      description: {
        ES: ''
      },
      date: '2019-05-01T12:00:00.000Z',
      techs: [],
      logo: {
        url: 'https://media-asgard.s3.eu-west-1.amazonaws.com/22/08/01/d8acad74-d7ca-48c2-a12e-405a3668c1c1_imatge-(1).jpg',
        alt: {
          ES: 'imatge (1).jpg'
        },
        id: 1,
        title: '',
        filename: '',
        ownerId: 1,
        uploadPath: ''
      },
      url: 'https://en.wikipedia.org/wiki/Washington_Award'
    },
    {
      type: 'AWARD',
      title: {
        ES: 'Honorary Doctorate by Bard College'
      },
      category: {
        ES: ''
      },
      description: {
        ES: ''
      },
      date: '2019-05-01T12:00:00.000Z',
      techs: [],
      logo: {
        url: 'https://media-asgard.s3.eu-west-1.amazonaws.com/22/08/01/f10dca88-3916-4e35-9810-892e3b020c2a_imatge1.jpg',
        alt: {
          ES: 'imatge1.jpg'
        },
        id: 1,
        title: '',
        filename: '',
        ownerId: 1,
        uploadPath: ''
      },
      url: 'https://www.technologyreview.com/2019/08/16/579/margaret-hamilton/'
    },
    {
      type: 'AWARD',
      title: {
        ES: 'US Presidential Medal of Freedom'
      },
      category: {
        ES: ''
      },
      description: {
        ES: 'From Barack Obama, the highest civilian honor in the United States.'
      },
      date: '2016-05-01T12:00:00.000Z',
      techs: [],
      logo: {
        url: 'https://media-asgard.s3.eu-west-1.amazonaws.com/22/08/01/a9934965-37ba-4d9a-8d70-4359cce5df36_625098110.jpeg',
        alt: {
          ES: '625098110.0.jpeg'
        },
        id: 1,
        title: '',
        filename: '',
        ownerId: 1,
        uploadPath: ''
      },
      url: 'https://www.theverge.com/2016/11/23/13734214/apollo-software-engineer-margaret-hamilton-presidential-medal-of-freedom'
    },
    {
      type: 'AWARD',
      title: {
        ES: 'Honorary Doctorate by the Polythecnic University of Catalonia'
      },
      category: {
        ES: ''
      },
      description: {
        ES: ''
      },
      date: '2018-05-01T12:00:00.000Z',
      techs: [],
      logo: {
        url: 'https://media-asgard.s3.eu-west-1.amazonaws.com/22/08/01/a14e090a-0797-494f-9056-3436a3bf57e6_imatge.jpg',
        alt: {
          ES: 'imatge.jpg'
        },
        id: 1,
        title: '',
        filename: '',
        ownerId: 1,
        uploadPath: ''
      },
      url: 'https://www.upc.edu/en/press-room/news/investiture-of-margaret-hamilton-as-an-honorary-doctor-of-upc'
    },
    {
      type: 'AWARD',
      title: {
        ES: 'Outstanding Alumni Award'
      },
      category: {
        ES: ''
      },
      description: {
        ES: 'Given by Earlham College'
      },
      date: '2009-05-01T12:00:00.000Z',
      techs: [],
      logo: {
        url: 'https://media-asgard.s3.eu-west-1.amazonaws.com/22/08/01/df317b05-2779-4b2e-a5ad-357e1fc00f68_divyjwax0aackns.jpg',
        alt: {
          ES: 'DiVYJwaX0AACKNS.jpg'
        },
        id: 1,
        title: '',
        filename: '',
        ownerId: 1,
        uploadPath: ''
      },
      url: 'https://engineerbabu.com/blog/margaret-hamilton/#:~:text=Margaret%20Hamilton%20was%20honored%20by,Alumni%20Award%20from%20Earlham%20College.'
    },
    {
      type: 'AWARD',
      title: {
        ES: 'Augusta Ada Lovelace'
      },
      category: {
        ES: 'Award'
      },
      description: {
        ES: 'Given by the Association for Women in Computing.'
      },
      date: '1986-05-01T12:00:00.000Z',
      techs: [],
      logo: {
        url: 'https://media-asgard.s3.eu-west-1.amazonaws.com/22/08/01/c482397f-c057-49e2-ae98-cf62d4b11338_maxresdefault.jpg',
        alt: {
          ES: 'maxresdefault.jpg'
        },
        id: 1,
        title: '',
        filename: '',
        ownerId: 1,
        uploadPath: ''
      },
      url: 'https://en.wikipedia.org/wiki/Ada_Lovelace_Award'
    },
    {
      type: 'AWARD',
      title: {
        ES: 'NASA Exceptional Space Act Award'
      },
      category: {
        ES: ''
      },
      description: {
        ES: "The award included $37,200, the largest amount awarded to any individual in NASA's history."
      },
      date: '2003-05-01T12:00:00.000Z',
      techs: [],
      logo: {
        url: 'https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/27/a884b9a1-6531-426b-81ba-2f9a34312c1a_nasa_logo.png',
        alt: {
          ES: 'NASA_logo.svg.png'
        },
        id: 1,
        title: '',
        filename: '',
        ownerId: 1,
        uploadPath: ''
      }
    }
  ],
  education: [
    {
      type: 'DEGREE',
      title: {
        ES: 'Mathematics'
      },
      institution: 'University of Michigan',
      description: {
        ES: ''
      },
      from: '1950-05-01T12:00:00.000Z',
      to: '1955-05-01T12:00:00.000Z',
      techs: [],
      logo: {
        url: 'https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/27/96b1aaf2-f74a-4d62-8ca5-cee74f92eb54_225px-seal_of_the_un.png',
        alt: {
          ES: '225px-Seal_of_the_University_of_Michigan.svg.png'
        },
        id: 1,
        title: '',
        filename: '',
        ownerId: 1,
        uploadPath: ''
      }
    },
    {
      type: 'DEGREE',
      title: {
        ES: 'BA in Mathematics'
      },
      institution: 'Earlham College',
      description: {
        ES: ''
      },
      from: '1955-05-01T12:00:00.000Z',
      to: '1958-05-01T12:00:00.000Z',
      techs: [],
      logo: {
        url: 'https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/27/429c9f38-2581-4d2c-88be-e2d292360a53_earlham_college_seal.png',
        alt: {
          ES: 'Earlham_College_Seal.png'
        },
        id: 1,
        title: '',
        filename: '',
        ownerId: 1,
        uploadPath: ''
      }
    },
    {
      type: 'DEGREE',
      title: {
        ES: 'Minor in Philosophy'
      },
      institution: 'Earlham College',
      description: {
        ES: ''
      },
      from: '1957-05-01T12:00:00.000Z',
      to: '1958-05-01T12:00:00.000Z',
      techs: [],
      logo: {
        url: 'https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/27/9749545c-bcce-49e6-ab8f-1d3604deb887_earlham_college_seal.png',
        alt: {
          ES: 'Earlham_College_Seal.png'
        },
        id: 1,
        title: '',
        filename: '',
        ownerId: 1,
        uploadPath: ''
      }
    }
  ],
  certifications: [],
  bookmarks: [
    {
      type: 'READING',
      title: {
        ES: "Margaret Hamilton, the woman who coded Apollo 11's software"
      },
      category: {
        ES: ''
      },
      author: 'El País',
      description: {
        ES: ''
      },
      url: 'https://elpais.com/tecnologia/2018/10/22/actualidad/1540207046_513939.html',
      logo: {
        id: 18925,
        filename: 'el-pais.svg',
        title: 'el-pais.svg',
        url: 'https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/28/3eb5d34e-d2eb-4c4d-bb53-a2541393c0cd_el-pais.svg',
        uploadPath:
          'https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/28/3eb5d34e-d2eb-4c4d-bb53-a2541393c0cd_el-pais.svg',
        alt: {
          ES: 'el-pais.svg'
        },
        ownerId: 8548
      }
    }
  ],
  views: { publicProfileDefaultView: 'classic', publicProfileIndexable: false }
};

export default CvApplicationSampleManfredite;
